import { Navigate, useSearchParams } from 'react-router-dom';
import { NyloplastDimensionsForm } from './NyloplastDimensionsForm';
import { WizardDimensionsForm } from './WizardDimensionsForm';

/**
 * Phase K.3 — Step 3 router. Dispatches to the per-family dimension form
 * based on the `family` query param. Nyloplast keeps its bespoke component
 * (basin-size button row); Precast and Cast Iron share the generic
 * `WizardDimensionsForm` driven by `structure_type.enabled_fields`.
 */
export function StructureDimensionsPage() {
  const [params] = useSearchParams();
  const family = params.get('family');

  if (family === 'nyloplast') return <NyloplastDimensionsForm />;
  if (family === 'precast') return <WizardDimensionsForm family="precast" />;
  if (family === 'castiron') return <WizardDimensionsForm family="castiron" />;
  if (family === 'curbthroat') return <WizardDimensionsForm family="curbthroat" />;
  return <Navigate to="/newstructure" replace />;
}
